import * as React from 'react';
import './TooltipContent.css';

interface Payload {
    value: string;
}

interface TooltipContentProps {
    type?: string;
    payload?: Payload[];
    label?: string;
    message: string;
}

export default class TooltipContent extends React.Component<TooltipContentProps> {
    render() {
        const { message } = this.props;

        return (
            <div className="custom-tooltip">
                <span>{message}</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/results/TooltipContent.tsx